import { AxiosResponse } from "axios";
import {
  ConfirmEmailProps,
  ConfirmEmailReturnType,
  LoginProps,
  LoginReturnType,
  RegisterProps,
  RegisterReturnType,
  RequestPasswordResetProps,
  RequestResetPasswordReturnType,
  ResendRecoverOTPProps,
  ResendRecoverOTPReturnType,
  ResendSignupOTPProps,
  ResendSignupOTPReturnType,
  ResetPasswordProps,
  ResetPasswordReturnType,
  UserTypeProps,
} from "../../declarations/userServices";
import { postRequest } from "../commonActions/post";
import { Requests } from "../../config/api";
import { getRequest } from "../commonActions/get";

export const Login = async ({
  email,
  password,
  setLoading,
}: LoginProps): Promise<LoginReturnType> => {
  try {
    setLoading && setLoading(true);
    const response: AxiosResponse = await postRequest({
      route: Requests.post.login,
      payload: { password, email },
    });
    setLoading && setLoading(false);

    const accessToken = response?.data?.accessToken;
    const status = response?.status;
    const message = response?.data?.message;
    const account = response?.data?.account;

    return {
      status: status,
      accessToken,
      message: message,
      account: account,
    };
  } catch (error) {
    setLoading && setLoading(false);
    throw error;
  }
};

export const AuthLogin = async (): Promise<void> => {
  try {
    const authUrl = "https://nobi-staging.onrender.com/api/v1/auth/auth0-login";
    // console.log('auturl', authUrl)
    window.location.href = `${authUrl}?redirect_uri=${encodeURIComponent(
      window.location.origin + "/callback"
    )}`;
  } catch (error) {
    console.error("Failed to initiate Auth0 login:", error);
  }
};

export const Signup = async ({
  email,
  password,
  setLoading,
  firstName,
  lastName,
  phoneNumber,
}: RegisterProps): Promise<RegisterReturnType> => {
  try {
    setLoading && setLoading(true);
    const response: AxiosResponse = await postRequest({
      route: Requests.post.signup,
      payload: {
        password,
        email,
        firstName,
        lastName,
        phoneNumber,
        role: "supplier",
      },
    });
    setLoading && setLoading(false);

    const status = response?.status;
    const message = response?.data?.message;
    const errors = response?.data?.message;

    return {
      status: status,
      message: message,
      errors,
    };
  } catch (error) {
    setLoading && setLoading(false);
    throw error;
  }
};

export const ConfirmEmail = async ({
  setLoading,
  otp,
}: ConfirmEmailProps): Promise<ConfirmEmailReturnType> => {
  try {
    setLoading && setLoading(true);
    const response: AxiosResponse = await postRequest({
      route: Requests.post.confirmEmail,
      payload: { otp },
    });
    setLoading && setLoading(false);

    const account = response?.data?.account;
    const token = response?.data?.accessToken;
    const status = response?.status;
    const message = response?.data?.message;
    const errors = response?.data?.message;

    return {
      status: status,
      message: message,
      errors,
      account,
      token,
    };
  } catch (error) {
    setLoading && setLoading(false);
    throw error;
  }
};

export const UserType = async ({
  type,
  numberOfEmployees,
  numberOfActivities,
  locations,
  reservation,
  legalCompanyName,
  website,
}: UserTypeProps): Promise<AxiosResponse> => {
  try {
    // const formData = new FormData();

    // formData.append("type", type);
    // formData.append("numberOfEmployees", numberOfEmployees);
    // formData.append("numberOfActivities", numberOfActivities);
    // formData.append("locations", locations);
    // formData.append("reservation", reservation);
    // formData.append("legalCompanyName", legalCompanyName);
    // formData.append("publicCompanyName", publicCompanyName);
    // formData.append("website", website);

    // console.log('type', type)
    // console.log("numberOfEmployees", numberOfEmployees)

    // console.log('formdata', formData)
    // formData.forEach((value, key) => {
    //   console.log(`${key}: ${value}`); // Should log "testKey: testValue"
    // });

    const jsonData = {
      type,
      numberOfEmployees,
      numberOfActivities,
      locations,
      reservation,
      legalCompanyName,
      website,
    };
    console.log("jsonData:", jsonData);
    const response: AxiosResponse = await postRequest({
      route: Requests.post.userType,
      payload: jsonData,
      // headers: { "Content-Type": "multipart/form-data" },
    });

    return response;
  } catch (error) {
    console.error("Error in userType API call", error);
    throw error;
  }
};

export const RequestResetPassword = async ({
  email,
  setLoading,
}: RequestPasswordResetProps): Promise<RequestResetPasswordReturnType> => {
  try {
    setLoading && setLoading(true);
    const response: AxiosResponse = await postRequest({
      route: Requests.post.requestPasswordReset,
      payload: { email },
    });
    setLoading && setLoading(false);

    const status = response?.status;
    const message = response?.data?.message;
    const errors = response?.data?.message;

    return {
      status: status,
      message: message,
      errors,
    };
  } catch (error) {
    setLoading && setLoading(false);
    throw error;
  }
};

export const ResetPassword = async ({
  otp,
  password,
  setLoading,
}: ResetPasswordProps): Promise<ResetPasswordReturnType> => {
  try {
    setLoading && setLoading(true);
    const response: AxiosResponse = await postRequest({
      route: Requests.post.resetPassword,
      payload: { otp, password },
    });
    setLoading && setLoading(false);

    const status = response?.status;
    const message = response?.data?.message;
    const errors = response?.data?.message;

    return {
      status: status,
      message: message,
      errors,
    };
  } catch (error) {
    setLoading && setLoading(false);
    throw error;
  }
};

export const ResendSignupOTP = async ({
  email,
  setLoading,
}: ResendSignupOTPProps): Promise<ResendSignupOTPReturnType> => {
  try {
    setLoading && setLoading(true);
    const response: AxiosResponse = await postRequest({
      route: Requests.post.resendSignupOTP,
      payload: { email },
    });
    setLoading && setLoading(false);

    const status = response?.status;
    const message = response?.data?.message;
    const errors = response?.data?.message;

    return {
      status: status,
      message: message,
      errors,
    };
  } catch (error) {
    setLoading && setLoading(false);
    throw error;
  }
};

export const ResendRecoverOTP = async ({
  email,
  setLoading,
}: ResendRecoverOTPProps): Promise<ResendRecoverOTPReturnType> => {
  try {
    setLoading && setLoading(true);
    const response: AxiosResponse = await postRequest({
      route: Requests.post.resendRecoverOTP,
      payload: { email },
    });
    setLoading && setLoading(false);

    const status = response?.status;
    const message = response?.data?.message;
    const errors = response?.data?.message;

    return {
      status: status,
      message: message,
      errors,
    };
  } catch (error) {
    setLoading && setLoading(false);
    throw error;
  }
};

export const GetFilteredSuppliers = async (
  page: number,
  limit: number,
  searchKey: string
): Promise<any> => {
  try {
    const response: AxiosResponse = await getRequest({
      route: `${Requests.get.getFilteredSuppliers}?page=${page}&limit=${limit}&searchKey=${searchKey}&role=supplier`,
    });

    const suppliers = response?.data?.users;
    const totalData = response?.data?.totalData;
    const status = response?.status;
    const message = response?.data?.message;
    const errors = response?.data?.message;

    return {
      status: status,
      suppliers: suppliers,
      totalData,
      message: message,
      errors: errors,
    };
  } catch (error) {
    console.error("Error in GetFilteredSuppliers:", error);
    throw error;
  }
};
